import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLuieStoel = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M30 28H10l1.82-18.21a2 2 0 0 1 2-1.79h12.39a2 2 0 0 1 2 1.79z"
    />
    <path
      fill="#FFBFA5"
      d="M12 30h2v3.31a.69.69 0 0 1-.69.69h-.61a.69.69 0 0 1-.69-.69V30zM26 30h2v3.31a.69.69 0 0 1-.69.69h-.61a.69.69 0 0 1-.69-.69V30z"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M34 20a4 4 0 0 0-8 0 8.76 8.76 0 0 0-6-2 8.76 8.76 0 0 0-6 2 4 4 0 1 0-5.38 3.74l1 6.23a2.44 2.44 0 0 0 2.4 2h15.92a2.44 2.44 0 0 0 2.4-2l1-6.23A4 4 0 0 0 34 20"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M12.475 18.025A3.5 3.5 0 0 0 10 17v-1a4.5 4.5 0 0 1 4.404 3.574A9.26 9.26 0 0 1 20 18a9.26 9.26 0 0 1 6.319 2.116l-.638.77A8.26 8.26 0 0 0 20.024 19l-.024.002-.024-.002a8.26 8.26 0 0 0-5.657 1.886l-.819.677V20.5a3.5 3.5 0 0 0-1.025-2.475"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLuieStoel);

export default ForwardRef;
